"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ProgressBarContainer = _styledComponents["default"].div.withConfig({
  displayName: "BestProgressBar__ProgressBarContainer",
  componentId: "sc-13z01lf-0"
})(["display:flex;justify-content:space-between;align-content:stretch;align-items:stretch;margin-bottom:10px;"]);

var ProgressNode = _styledComponents["default"].div.withConfig({
  displayName: "BestProgressBar__ProgressNode",
  componentId: "sc-13z01lf-1"
})(["display:flex;flex-direction:column;"]);

var LeftNode = (0, _styledComponents["default"])(ProgressNode).withConfig({
  displayName: "BestProgressBar__LeftNode",
  componentId: "sc-13z01lf-2"
})(["align-items:flex-start;"]);
var CenterNode = (0, _styledComponents["default"])(ProgressNode).withConfig({
  displayName: "BestProgressBar__CenterNode",
  componentId: "sc-13z01lf-3"
})(["align-items:center;"]);
var RightNode = (0, _styledComponents["default"])(ProgressNode).withConfig({
  displayName: "BestProgressBar__RightNode",
  componentId: "sc-13z01lf-4"
})(["align-items:flex-end;"]);

var ProgressNodePath = _styledComponents["default"].div.withConfig({
  displayName: "BestProgressBar__ProgressNodePath",
  componentId: "sc-13z01lf-5"
})(["display:flex;flex-direction:column;width:100%;height:100%;"]);

var ProgressNodeLabel = _styledComponents["default"].div.withConfig({
  displayName: "BestProgressBar__ProgressNodeLabel",
  componentId: "sc-13z01lf-6"
})(["min-height:1.5em;font-style:italic;color:", ";"], function (props) {
  return props.styles.nodeLabelColor;
});

var ProgressNodePoint = _styledComponents["default"].div.withConfig({
  displayName: "BestProgressBar__ProgressNodePoint",
  componentId: "sc-13z01lf-7"
})(["display:flex;width:100%;height:100%;justify-content:center;"]);

var ProgressNodeBlock = _styledComponents["default"].div.withConfig({
  displayName: "BestProgressBar__ProgressNodeBlock",
  componentId: "sc-13z01lf-8"
})(["height:19px;width:19px;background-color:", ";box-shadow:0 0 4px 0 rgba(0,0,0,0.2);border-radius:2px;&.complete{border:1px solid ", ";background-color:#49c083;}"], function (props) {
  return props.styles.nodeBackgroundColor;
}, function (props) {
  return props.styles.completeColor;
});

var ProgressPath = _styledComponents["default"].div.withConfig({
  displayName: "BestProgressBar__ProgressPath",
  componentId: "sc-13z01lf-9"
})(["display:flex;width:100%;height:19px;"]);

var ProgressPathLine = _styledComponents["default"].div.withConfig({
  displayName: "BestProgressBar__ProgressPathLine",
  componentId: "sc-13z01lf-10"
})(["height:33%;flex:1;align-self:center;background-color:", ";border-top:1px solid ", ";border-bottom:1px solid ", ";&.complete{background-color:#49c083;border-top:1px solid ", ";border-bottom:1px solid ", ";}"], function (props) {
  return props.styles.progressPathColor;
}, function (props) {
  return props.styles.progressPathBorderColor;
}, function (props) {
  return props.styles.progressPathBorderColor;
}, function (props) {
  return props.styles.completeBorderColor;
}, function (props) {
  return props.styles.completeBorderColor;
});

var Node = function Node(_ref) {
  var label = _ref.label,
      beforeCompleted = _ref.beforeCompleted,
      currentCompleted = _ref.currentCompleted,
      index = _ref.index,
      barAsStep = _ref.barAsStep,
      styles = _ref.styles;
  var isLastNodeStep = barAsStep ? currentCompleted : beforeCompleted;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(ProgressNodeLabel, {
    styles: styles
  }, _react["default"].createElement("span", null, label)), _react["default"].createElement(ProgressNodePoint, null, index !== 0 && _react["default"].createElement(ProgressPathLine, {
    className: beforeCompleted ? "complete" : "",
    styles: styles
  }), _react["default"].createElement(ProgressNodeBlock, {
    className: index === 0 || isLastNodeStep ? "complete" : "",
    styles: styles
  }), index !== -1 && _react["default"].createElement(ProgressPathLine, {
    className: currentCompleted ? "complete" : "",
    styles: styles
  })));
};

Node.propTypes = {
  label: _propTypes["default"].string.isRequired,
  beforeCompleted: _propTypes["default"].bool.isRequired,
  currentCompleted: _propTypes["default"].bool.isRequired,
  index: _propTypes["default"].number.isRequired,
  barAsStep: _propTypes["default"].bool.isRequired,
  styles: _propTypes["default"].object.isRequired
};

var NodePath = function NodePath(_ref2) {
  var completed = _ref2.completed,
      index = _ref2.index,
      styles = _ref2.styles;
  return _react["default"].createElement(ProgressNodePath, {
    key: index + " path"
  }, _react["default"].createElement(ProgressNodeLabel, {
    styles: styles
  }), _react["default"].createElement(ProgressPath, null, _react["default"].createElement(ProgressPathLine, {
    className: completed ? "complete" : "",
    styles: styles
  })));
};

NodePath.propTypes = {
  completed: _propTypes["default"].bool.isRequired,
  index: _propTypes["default"].number.isRequired,
  styles: _propTypes["default"].object.isRequired
};

var NodeAndPath = function NodeAndPath(_ref3) {
  var label = _ref3.label,
      currentCompleted = _ref3.currentCompleted,
      beforeCompleted = _ref3.beforeCompleted,
      index = _ref3.index,
      barAsStep = _ref3.barAsStep,
      styles = _ref3.styles;
  return _react["default"].createElement(_react["default"].Fragment, null, index === 0 && _react["default"].createElement(LeftNode, null, _react["default"].createElement(Node, {
    label: label,
    currentCompleted: currentCompleted,
    index: index,
    styles: styles,
    barAsStep: barAsStep
  })), index === -1 && _react["default"].createElement(RightNode, null, _react["default"].createElement(Node, {
    label: label,
    currentCompleted: currentCompleted,
    beforeCompleted: beforeCompleted,
    index: -1,
    styles: styles,
    barAsStep: barAsStep
  })), index > 0 && _react["default"].createElement(CenterNode, null, _react["default"].createElement(Node, {
    label: label,
    beforeCompleted: beforeCompleted,
    currentCompleted: currentCompleted,
    index: index,
    styles: styles,
    barAsStep: barAsStep
  })), index !== -1 && _react["default"].createElement(NodePath, {
    completed: currentCompleted,
    index: index,
    styles: styles
  }));
};

NodeAndPath.propTypes = {
  label: _propTypes["default"].string.isRequired,
  currentCompleted: _propTypes["default"].bool.isRequired,
  beforeCompleted: _propTypes["default"].bool.isRequired,
  index: _propTypes["default"].number.isRequired,
  barAsStep: _propTypes["default"].bool.isRequired,
  styles: _propTypes["default"].object.isRequired
};

var BestProgressBar = function BestProgressBar(_ref4) {
  var nodes = _ref4.nodes,
      styles = _ref4.styles,
      barAsStep = _ref4.barAsStep;
  var Theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var DefaultStyle = {
    nodeLabelColor: Theme["slate-grey"],
    nodeBackgroundColor: Theme["light-grey"],
    completeColor: Theme["sky-blue"],
    progressPathColor: Theme["grey"],
    completeBorderColor: Theme["sky-blue"]
  };

  var CompStyles = _objectSpread({}, DefaultStyle, {}, styles);

  var nodeArray = [];

  for (var i = 0; i < nodes.length; i++) {
    nodeArray.push(_react["default"].createElement(NodeAndPath, {
      key: i,
      label: nodes[i].label,
      currentCompleted: !!nodes[i].completed,
      beforeCompleted: i !== 0 && nodes[i - 1].completed,
      index: i === nodes.length - 1 ? -1 : i,
      styles: CompStyles,
      barAsStep: barAsStep
    }));
  }

  return _react["default"].createElement(ProgressBarContainer, null, nodeArray);
};

BestProgressBar.defaultProps = {
  styles: {},
  barAsStep: false
};
BestProgressBar.propTypes = {
  /** Overrideable styles */
  styles: _propTypes["default"].shape({
    nodeLabelColor: _propTypes["default"].string,
    nodeBackgroundColor: _propTypes["default"].string,
    completeColor: _propTypes["default"].string,
    progressPathColor: _propTypes["default"].string,
    completeBorderColor: _propTypes["default"].string
  }),

  /** Array of objects to represent steps in the progress bar.  Each object consist of label(string) and completed(boolean) */
  nodes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    completed: _propTypes["default"].bool.isRequired
  })).isRequired,

  /** Whether the bar or node represents current step */
  barAsStep: _propTypes["default"].bool
};
var _default = BestProgressBar;
exports["default"] = _default;